var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04893 18.9758L19.4901 13.6428C20.0676 13.3933 20.0676 12.5805 19.4901 12.331L7.04893 6.99802C6.57837 6.79126 6.05791 7.14061 6.05791 7.64681L6.05078 10.9336C6.05078 11.2901 6.31458 11.5966 6.67106 11.6394L16.7452 12.9869L6.67106 14.3273C6.31458 14.3772 6.05078 14.6838 6.05078 15.0402L6.05791 18.327C6.05791 18.8332 6.57837 19.1826 7.04893 18.9758Z",
    fill: "#2a2a2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSendButton);
export default __webpack_public_path__ + "static/media/whatsappSendButton.0a577a7a4ba22bfbe99a8336d084097c.svg";
export { ForwardRef as ReactComponent };